"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ImportTemplateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onKeepExisting: () => void;
  onUseTemplate: () => void;
  templateName: string;
  hasExistingItems: boolean;
}

export function ImportTemplateDialog({
  isOpen,
  onClose,
  onKeepExisting,
  onUseTemplate,
  templateName,
  hasExistingItems,
}: ImportTemplateDialogProps) {
  if (!hasExistingItems) {
    // If there are no existing items, just import the template
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Import Template with Items</DialogTitle>
          <DialogDescription className="space-y-2">
            <p>
              The template &quot;{templateName}&quot; contains items that are already
              placed in tiers.
            </p>
            <p className="font-medium">What would you like to do?</p>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>
                <strong>Keep template placement:</strong> Import items in their
                designated tiers
              </li>
              <li>
                <strong>Move to sidebar:</strong> Import all items as unassigned
                in the sidebar
              </li>
            </ul>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button onClick={onUseTemplate} variant="outline">
            Move to Sidebar
          </Button>
          <Button onClick={onKeepExisting}>
            Keep Template Placement
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
